
















import { defineComponent } from "@vue/composition-api";
import { Announcement } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";
import CustomScroll from "@/components/CustomScroll";
import WysiwygViewer from "@/components/WysiwygViewer";

export default defineComponent({
  name: "AnnouncementsItem",
  components: { CustomScroll, BaseIconButton, WysiwygViewer, BaseAvatar },
  props: {
    announcement: { type: Object as () => Announcement, required: true },
    closed: { type: Boolean, required: true },
  },
});
